import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AuthenticationService } from "../authentication.service";


@Injectable()
export class EmployeeRouteInterceptor implements HttpInterceptor {

  constructor(private _authService: AuthenticationService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.includes('[employee-id]')) {
            const userId = this._authService.getUserId();
            if (userId) {
                const cloneReq = req.clone({url: req.url.replace('[employee-id]', userId.toString())});
                return next.handle(cloneReq);
            }
        }
        return next.handle(req);
    }
}